import Button from "@material-ui/core/Button";
import { createMuiTheme, makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import React from "react";
import { theme } from "../App";
import DrugProtocols from "../assets/medical_directives_bls_2026-27.pdf";
import ShabbosProtocols from "../assets/shabbos_2026_v2.pdf";

const useStyles = makeStyles((theme) => ({
  main: {
    padding: 10,
    display: "grid",
    gap: 15,
    maxWidth: 325,
  },
}));

const ProtocolsView = () => {
  const classes = useStyles();

  return (
    <div className={classes.main}>
      <h1>Directives</h1>

      <Button variant="contained" color="secondary" href={DrugProtocols}>
        2026-2027 Medical Directives
      </Button>
      <Button variant="contained" color="secondary" href={ShabbosProtocols}>
        וחי בהם
      </Button>
    </div>
  );
};

const Protocols = (props) => (
  <ThemeProvider theme={createMuiTheme(theme)}>
    <ProtocolsView {...props} />
  </ThemeProvider>
);

export default Protocols;
